import {
  Actor,
  Animation,
  AnimationStrategy,
  Collider,
  CollisionContact,
  CollisionType,
  Engine,
  Keys,
  Side,
  SpriteSheet,
  vec,
} from 'excalibur';
import { CONFIG, LevelKey } from '../config';
import { Resources } from '../resources';
import { COLLISION_GROUPS } from '../collision-groups';

export class Santa extends Actor {
  private readonly spriteSheet = SpriteSheet.fromImageSource({
    image: Resources.Santa,
    grid: {
      rows: 1,
      columns: 10,
      spriteWidth: 48,
      spriteHeight: 48,
    },
  });
  private grounded = false;
  private striking = false;
  private facingLeft = false;

  constructor(level: LevelKey) {
    const { x, y } = CONFIG.levels[level].santa;
    super({
      name: 'Santa',
      pos: vec(x - 20, y - 140),
      width: 48,
      height: 48,
      // anchor: vec(0.5, 1),
      collisionType: CollisionType.Active,
      collisionGroup: COLLISION_GROUPS.santa,
      z: 10,
    });
  }

  override onInitialize(engine: Engine): void {
    this.body.useGravity = true;
    this.body.bounciness = 0;
    this.collider.useBoxCollider(30, 30, vec(0.5, 0.5), vec(0.0, 0.0));

    this.setupAnimations();
  }

  override onPreUpdate(engine: Engine): void {
    this.handleInput(engine);
  }

  override onPostCollisionResolve(_self: Collider, _other: Collider, side: Side, _contact: CollisionContact): void {
    if (side === Side.Bottom) {
      this.grounded = true;
    }
  }

  private setupAnimations(): void {
    const stand = Animation.fromSpriteSheet(this.spriteSheet, [0, 1, 2, 1], 125);
    const walk = Animation.fromSpriteSheet(this.spriteSheet, [3, 4, 5, 6], 83);
    const strike = Animation.fromSpriteSheet(this.spriteSheet, [8, 9], 125, AnimationStrategy.End);

    strike.events.on('end', () => {
      this.striking = false;
      this.graphics.use('stand');
    });

    this.graphics.add('stand', stand);
    this.graphics.add('walk', walk);
    this.graphics.add('strike', strike);
    this.graphics.use('stand');
  }

  private handleInput(engine: Engine): void {
    const keyboard = engine.input.keyboard;

    if (keyboard.wasPressed(Keys.A)) {
      this.startStrike();
    }

    if (this.striking) {
      this.vel.x = 0;
      return;
    }

    this.vel.x = 0;

    if (keyboard.isHeld(Keys.Left)) {
      this.vel.x = -CONFIG.santa.speed;
      this.graphics.use('walk');
      this.graphics.flipHorizontal = true;
      this.facingLeft = true;
    } else if (keyboard.isHeld(Keys.Right)) {
      this.vel.x = CONFIG.santa.speed;
      this.graphics.use('walk');
      this.graphics.flipHorizontal = false;
      this.facingLeft = false;
    } else {
      this.graphics.use('stand');
    }

    if (keyboard.wasPressed(Keys.S) && this.grounded) {
      this.vel.y = -CONFIG.santa.jumpPower;
      this.grounded = false;
      Resources.Jump.play();
    }
  }

  private startStrike(): void {
    if (this.striking) {
      return;
    }

    this.striking = true;
    Resources.Strike.play();

    const strikeAnimation = this.graphics.getGraphic('strike');
    if (strikeAnimation instanceof Animation) {
      strikeAnimation.reset();
    }
    this.graphics.use('strike');
  }

  isStriking(): boolean {
    return this.striking;
  }

  facingDirection(): number {
    return this.facingLeft ? -1 : 1;
  }
}
